import { Expose } from "class-transformer";
import { VehicleIssueStatusEnum } from "@altertec_gparn/lib";

export class UpdateVehicleIssueStatusBulkDto {
  @Expose()
  ids: string[];

  @Expose()
  status: VehicleIssueStatusEnum;
}
